import { AxiosRequestConfig } from 'axios'
import { CallEffect, PutEffect } from 'redux-saga/effects'

import { ApiResponse, ErrorData } from '../../interfaces'
import { ISendTo } from '../sendTo'

export interface IError extends ErrorData {
  status: number
}

export interface ILogin {
  accessToken: string
  expiresIn: number
  refreshToken: string
  success: boolean
  tokenType: string
}

export interface ISendLoginPayload {
  type: 'simple' | 'social'
  socialToken?: string
  username?: string
  password?: string
  recaptchaCode?: string
  middleware?: AxiosRequestConfig
  userId: string
}

export type LoginGeneratorYield =
  | CallEffect<ApiResponse<ILogin | ErrorData>>
  | PutEffect<ISendLoginSuccess | ISendLoginFail | ISendTo>

export const SEND_LOGIN = 'SEND_LOGIN'
export const SEND_LOGIN_SUCCESS = 'SEND_LOGIN_SUCCESS'
export const SEND_LOGIN_FAIL = 'SEND_LOGIN_FAIL'

export const RESET_LOGIN = 'RESET_LOGIN'
export const UPDATE_SOCIAL_TOKEN = 'UPDATE_SOCIAL_TOKEN'

export interface ISendLogin {
  type: typeof SEND_LOGIN
  payload: ISendLoginPayload
}

export interface ISendLoginSuccess {
  type: typeof SEND_LOGIN_SUCCESS
  payload: ILogin
}

export interface ISendLoginFail {
  type: typeof SEND_LOGIN_FAIL
  payload: IError
}

export interface IUpdateSocialToken {
  type: typeof UPDATE_SOCIAL_TOKEN
  payload: string
}

export interface IResetLogin {
  type: typeof RESET_LOGIN
}

export type LoginDispatchTypes = ISendLogin | ISendLoginSuccess | ISendLoginFail | IUpdateSocialToken | IResetLogin
